import HttpClient from "./index"
import ApiRoutes, { baseUrl } from "../config/endpoints"
import { getTokenLocal } from "../helper/utils"

export default class GroupProfileAPI extends HttpClient {
  constructor() {
    super(baseUrl)
    this._initializeRequestInterceptor()
  }

  // Group profile
  metricDetails = ApiRoutes.groupProfile.MetricDetails
  groupInfo = ApiRoutes.groupProfile.groupInfo
  metricAssign = ApiRoutes.groupProfile.metricAssign
  metricAssignRemove = ApiRoutes.groupProfile.metricAssignRemove
  groupDetailsRegionsByGroups =
    ApiRoutes.groupProfile.GroupDetailsRegionsByGroups
  groupDetailsPracticesByRegions =
    ApiRoutes.groupProfile.GroupDetailsPracticesByRegions
  assignPc = ApiRoutes.groupProfile.AssignPc
  assignAdvisor = ApiRoutes.groupProfile.AssignAdvisor
  assignCsm = ApiRoutes.groupProfile.AssignCsm
  groupStatus = ApiRoutes.groupProfile.GroupStatus
  allPractices = ApiRoutes.groupProfile.AllPractices
  updatePracticeStatus = ApiRoutes.groupProfile.UpdatePracticeStatus

  _initializeRequestInterceptor = () => {
    this.instance.interceptors.request.use(this._handleRequest)
  }

  _handleRequest = async (axiosConfig: any) => {
    return axiosConfig
  }

  getMetricDetailsById = (token: string, group_sk: any) => {
    return this.instance({
      method: this.metricDetails.Method,
      url: this.metricDetails.EndPoint(group_sk),
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {},
    })
  }
  getgroupInfoById = (token: string, group_sk: any) => {
    return this.instance({
      method: this.groupInfo.Method,
      url: this.groupInfo.EndPoint(group_sk),
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {},
    })
  }

  getAllPractices = (token: string, group_sk: any) => {
    return this.instance({
      method: this.allPractices.Method,
      url: this.allPractices.EndPoint(group_sk),
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {},
    })
  }
  changePracticeStatus = (
    token: string,
    practice_sk: any,
    practice_status: any,
  ) => {
    return this.instance({
      method: this.updatePracticeStatus.Method,
      url: this.updatePracticeStatus.EndPoint(practice_sk),
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: { practice_status },
    })
  }

  postMetricAssigned = (token: string, data: any) => {
    return this.instance({
      method: this.metricAssign.Method,
      url: this.metricAssign.EndPoint,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data,
    })
  }

  removeAssigned = (token: string, data: any) => {
    return this.instance({
      method: this.metricAssignRemove.Method,
      url: this.metricAssignRemove.EndPoint,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {
        group_sk: data?.group_sk,
        metric_id: data?.metric_id,
      },
    })
  }

  updateGroupStatus = (token: string, status: string, groupSk: any) => {
    return this.instance({
      method: this.groupStatus.Method,
      url: this.groupStatus.EndPoint(groupSk),
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {
        group_status: status,
      },
    })
  }

  getGroupDetailsRegionsByGroups = (token: string, groups: any) => {
    return this.instance({
      method: this.groupDetailsRegionsByGroups.Method,
      url: this.groupDetailsRegionsByGroups.EndPoint,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {
        group_list: groups,
      },
    })
  }

  getGroupDetailsPracticesByRegions = (
    token: string,
    groups: any,
    regions: any,
  ) => {
    return this.instance({
      method: this.groupDetailsPracticesByRegions.Method,
      url: this.groupDetailsPracticesByRegions.EndPoint,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {
        group_list: groups,
        region_list: regions,
      },
    })
  }

  updatePc = (token: string, data: any) => {
    return this.instance({
      method: this.assignPc.Method,
      url: this.assignPc.EndPoint(data?.groupSk, data?.gaId),
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: null,
    })
  }

  updateAdvisor = (token: string, data: any) => {
    return this.instance({
      method: this.assignAdvisor.Method,
      url: this.assignAdvisor.EndPoint(data?.groupSk, data?.advisorId),
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: null,
    })
  }

  updateCsm = (token: string, data: any) => {
    return this.instance({
      method: this.assignCsm.Method,
      url: this.assignCsm.EndPoint(data?.groupSk, data?.csmId),
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: null,
    })
  }
}
